import React, { Component } from 'react'
import Question from './Question'
import {getPartIIQuestion} from './AnswerFormats'

const Entry = (props) => {
    return (
    <React.Fragment>
        <label htmlFor={props.name}>{props.name}</label>
        <input
            type="number" 
            name={props.name} 
            value={props.state[props.name]} 
            onChange={props.handleChange}
            min = {props.range[0]}
            max = {props.range[1]}
            />
    </React.Fragment>
)}

export default class Finder extends Component {
    state = {
        questions:[],
        Year:"",
        Test:"",
        Number:"",
        dropButton:false,
        maxQuestion:60,
    }

    hideQuestion = (index) => {
        const Qslice = this.state.questions.slice();
        this.setState({questions:Qslice.filter((v,i)=> i!==index)})
    }

    handleChange = (event) => {
        let {name,value} = event.target;
        this.setState({[name]: value});
    }
    handleClick = (test) => {
        if (test==="PartII")this.setState({maxQuestion:8});
        this.setState({Test:test,dropButton:false});
    }
    showmenu = () => {
        this.setState({dropButton:true});
    }
    hidemenu = () => {
        this.setState({dropButton:false});
    }

    submitForm = () => {
        const {Year,Number,Test} = this.state;
        const question = {year: Year,number:Number,test:Test};
        this.setState({questions:[...this.state.questions,question],Test: "", Year: "", Number:""});
    }

    answer = (correct,categories) => {
        this.setState(prevState => {
          let index = correct ? 0 : 1;
          let updatedStats = {};
          Object.assign(updatedStats,prevState.stats);
          //console.log(prevState.stats);
          categories.forEach((v) => {
              updatedStats[v][index]++;
          })
          //console.log("answered - " + categories);
          return {stats: updatedStats};
        });
      }

    render() {
        let test;
        switch(this.state.Test){
            case "L": test="Locals"; break;
            case "N": test="USNCO Part I"; break;
            case "PartII": test="USNCO Part II"; break;
            default: test=""; 
        }
        return (
            <div>
            <div className = "margin20">
            {this.state.questions.map((q,i) => {
                let question;
                if (q.test==="PartII") {
                    let qToNumbers = {year:parseInt(q.year),number:parseInt(q.number)}
                    question=<div className = "aQuestion">
                        <div className="flexBox">
                            <div className = "problemName">{q.year+" USNCO Part II Problem "+q.number}</div>
                            </div>
                        {getPartIIQuestion(qToNumbers)}
                        </div>
                }
                else question=<Question 
                    data={q} 
                    key={q.year+" "+q.test+" "+q.number} 
                    hide={() => this.hideQuestion(i)}
                    answer={this.answer}
                />
                return question;
            })}
            </div>
            <div className = "form">
                <form>
                    <Entry 
                        name="Year" 
                        state={this.state} 
                        handleChange={this.handleChange}
                        range = {[2010,2020]}
                        /> 
                    <label htmlFor={"Test"}>Test</label>
                    <div 
                        className="dropdown" 
                        onMouseLeave = {this.hidemenu}>
                    <input 
                        type="text" 
                        name={"Test"} 
                        value={test}
                        readOnly={true}
                        onClick = {this.showmenu} 
                        />
                    {this.state.dropButton && (
                    <div className="content">
                        <div 
                            className = "dropButton" 
                            onClick={() => this.handleClick("L")}>Locals</div>
                        <div 
                            className = "dropButton" 
                            onClick={() => this.handleClick("N")}>USNCO Part I</div>
                        <div 
                            className = "dropButton" 
                            onClick={() => this.handleClick("PartII")}>USNCO Part II</div>
                    </div>
                    )}
                    </div> 
                    <Entry 
                        name="Number" 
                        state={this.state} 
                        handleChange={this.handleChange}
                        range = {[1,this.state.maxQuestion]}
                        /> 
                    <input 
                        type="button" 
                        value="Submit" 
                        onClick={this.submitForm}/>
                </form>
            </div>
            </div>
        )
    }
}
